<template>
  <div>
    <!-- HEADER -->
    <FichaTecnicaTarefaHeader
      :dadosFichaTecnica="dadosFichaTecnicaTarefa"
      :circuito="circuitoSelecionado"
      :pcoTarefaId="$route.params.pco_tarefa_id"
      :alertaSolicitacaoCancelamento="alertaSolicitacaoCancelamento"
      @abrirModalProjeto="abrirModalProjeto = true"
      @abrirModalAgendVisitaTecnica="abrirModalAgendVisitaTecnica = true"
    />

    <div class="content-body mt-4">
      <!-- INFO CARDS COMPONENTIZADO -->
      <FichaTecnicaInfoCards
        :dadosFichaTecnica="dadosFichaTecnicaTarefa"
        :circuito="circuitoSelecionado"
      />

      <!-- SLA CARDS COMPONENTIZADO -->
      <FichaTecnicaSLACards
        :dadosFichaTecnica="dadosFichaTecnicaTarefa"
        :circuito="circuitoSelecionado"
        :tarefaSelecionada="tarefaSelecionada"
        :provedorTipo="provedorTipo"
      />

      <AbaComponent 
        class="mt-5" 
        :circuito="circuitoSelecionado"
        :provedorTipo="provedorTipo"
      />

      <!-- MACROPROCESSOS TIMELINE COMPONENTIZADO -->
      <MacroProcessosTimeline :timelineItems="timelineMacroprocesso" />

      <!-- ACOES E TRATATIVAS -->
      <AcoesTratativasComponent 
        :dadosFichaTecnica="dadosFichaTecnicaTarefa"
        @atualizaFormularioDinamico="atualizaHistorico"
        :abrirModalTratativas="mostrarModalTratativas"
        :key="mostrarModalTratativas"
      />

      <!-- BLOCO SECTION COMPONENTIZADO -->
      <BlocoSection
        v-if="hasBloco"
        :dadosFichaTecnica="dadosFichaTecnicaTarefa"
        :panels="blocoPanels"
        @excluirBloco="excluindoBloco"
        @togglePanel="blocoPanels = blocoPanels == 0 ? 1 : 0"
      />

      <!-- TAREFAS PERCORRIDAS COMPONENTIZADO -->
      <TarefasPercorridasSection
        :circuito="circuitoSelecionado"
        :pcoTarefaId="$route.params.pco_tarefa_id"
        :panels.sync="painelTarefasPercorridas"
        :tarefa="dadosFichaTecnicaTarefa"
      />

      <!-- HISTORICO -->
      <HistoricoComponent 
        :tarefa="dadosFichaTecnicaTarefa" 
        :circuito="circuitoSelecionado" 
        :historico="dadosHistoricoFichaTecnica"
      />
    </div>

    <!-- MODAIS COMPONENTIZADO -->
    <FichaTecnicaModais
      :abrirModalProjeto="abrirModalProjeto"
      :circuito="circuitoSelecionado"
      :dadosFichaTecnica="dadosFichaTecnicaTarefa"
      :abrirModalAgendVisitaTecnica="abrirModalAgendVisitaTecnica"
      @fecharModalAgendVisitaTecnica="abrirModalAgendVisitaTecnica = false"
    />

    <!-- BOTOES FLUTUANTES COMPONENTIZADO -->
    <FichaTecnicaBotoesFlutuantes
      :mostrarBotaoMaximizarAtualizacao="false"
      :mostrarBotaoMaximizarWf1="false"
      :mostrarBotaoMaximizarAnotacoes="false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { recuperarCookie, removerCookie } from '@/common/boot/CookiesHandler.js';
import moment from 'moment';
import moduleReload from '@/common/mixins/module-reload.js';
import { getProvedorAtivo, getProvedorAtivoTipo } from '../helpers/provedorHelper';
import { formatarOS } from '@/common/helpers/StringHelper';

import FichaTecnicaTarefaHeader from '../components/FichaTecnicaTarefaHeader.vue';
import FichaTecnicaInfoCards from '../components/FichaTecnicaInfoCards.vue';
import FichaTecnicaSLACards from '../components/FichaTecnicaSLACards.vue';
import MacroProcessosTimeline from '../components/MacroProcessosTimeline.vue';
import BlocoSection from '../components/BlocoSection.vue';
import TarefasPercorridasSection from '../components/TarefasPercorridasSection.vue';
import FichaTecnicaModais from '../components/FichaTecnicaModais.vue';
import FichaTecnicaBotoesFlutuantes from '../components/FichaTecnicaBotoesFlutuantes.vue';
import AbaComponent from '../components/nova_ficha/abas/AbaComponent.vue';
import AcoesTratativasComponent from '../components/nova_ficha/AcoesTratativasComponent.vue';
import HistoricoComponent from '../components/nova_ficha/HistoricoComponent.vue';

// import ModalPcoCirAnotacaoComponent from '@/modules/sgp/pco-circuito-anotacoes/components/ModalPcoCirAnotacaoComponent'
//import ModalPcoCirAdocaoComponent from '@/modules/sgp/pco-circuito-adocao/components/ModalPcoCirAdocaoComponent'
// import TratativasSemTratamentoComponent from '../components/TratativasSemTratamentoComponent'
// import ChecklistPreparacaoAtivacaoModal from '@/modules/sgp/checklist-agendamento/components/ChecklistPreparacaoAtivacaoModal'
// import SGPInfoCardComponent from '../components/nova_ficha/SGPInfoCardComponent.vue';
// import BlocoTableComponent from '../components/nova_ficha/BlocoTableComponent.vue';
// import FlowTimelineComponent from '../components/nova_ficha/FlowTimelineComponent.vue';
// import EventBus from '@/common/helpers/EventBus'
// import CtrlStar21ClientesContatosPage from '@/modules/sgp/ctrl-star21-clientes-contatos/pages/CtrlStar21ClientesContatosPage'
// import OrdemDeServicoPage from '@/modules/sgp/modos/pages/OrdemDeServicoPage.vue'
// import SGPTabsMenuHorizontalComponent from '../../../../common/sgp-components/SGPOrdemServico/SGPTabsMenuHorizontalComponent.vue';
// import SGPLoadingComponent from '@/common/sgp-components/SGPLoadingComponent.vue'
// import ModalWf1Component from '@/modules/sgp/pco-circuito-wf1/components/ModalWf1Component.vue'

export default {
  name: "FichaTecnicaTarefaPage",

  mixins: [moduleReload],

  components: {
    FichaTecnicaTarefaHeader,
    FichaTecnicaInfoCards,
    FichaTecnicaSLACards,
    MacroProcessosTimeline,
    BlocoSection,
    TarefasPercorridasSection,
    FichaTecnicaModais,
    FichaTecnicaBotoesFlutuantes,
    AbaComponent,
    AcoesTratativasComponent,
    HistoricoComponent,
    // Componentes comentados mantidos para referência
    // ModalPcoCirAnotacaoComponent,
    //ModalPcoCirAdocaoComponent,
    // TratativasSemTratamentoComponent,
    // ChecklistPreparacaoAtivacaoModal,
    // CtrlStar21ClientesContatosPage,
    // OrdemDeServicoPage,
    // SGPLoadingComponent,
    // SGPTabsMenuHorizontalComponent,
    // ModalWf1Component
  },

  data () {
    return {
      blocoPanels: 0,
      painelTarefasPercorridas: 0,
      tarefaSelecionada: {},
      abrirModalSemTratamento: false,
      alertaSolicitacaoCancelamento: true,
      abrirModalProjeto: false,
      ficha: {},
      abrirModalDesfazerBlocoInteiro: false,
      mostrarModalTratativas: false,
      abrirModalAgendVisitaTecnica: false,
      // Variáveis comentadas mantidas para referência
      // formularioId: '',
      // atualizarTela: false,
      // mostrarTabsTarefas: false,
      // tarefaEmAtendimento: {},
      // listaDeTratamentos: [],
      // abrirModalImage: false,
      // abrirModalAnotacao: false,
      // abrirModalWf1: false,
      // abrirModalMulta: false,
      // abrirModalClientesContatos: false,
      // abrirSolicitacaoMobilidade: false,
      // abrirModalChecklistAgendamento: false,
      // abrirModalOrdemServico: false,
      // abrirModalConsulta: false,
      // mostrarBotaoMaximizarAnotacoes: false,
      // mostrarBotaoMaximizarAtualizacao: false,
      // mostrarBotaoMaximizarWf1: false,
    }
  },

  async created () {
    await this.carregarDados();
  },

  // destroyed () {
  //   EventBus.$off('abrirModalClientesContatos', this.abrirModalClientesContatos = false)
  // },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'loadingFichaTecnica',
      'dadosFichaTecnicaTarefa',
      'dadosHistoricoFichaTecnica',
      'listaDeLogsPcoTarefas',
      'dadosAdocao'
    ]),

    // ...mapGetters('pcoCircuitoSaip', [
    //   'dadosSaipPcoCircuito'
    // ]),

    ...mapGetters('ctrlTratativas', [
      'listaDeTratativasSemTratamento'
    ]),

    // ...mapGetters('pcoCircuitoAnotacoes', [
    //   'listaDePcoCircuitoAnotacoes',
    // ]),

    // ...mapGetters('processos', [
    //   'listaDeProcessos'
    // ]),

    ...mapGetters('automacao', ['buscandoAutomacao']),

    // Computed properties
    timelineMacroprocesso() {
      const workflow = this.dadosFichaTecnicaTarefa.workflow;

      if (!workflow || !workflow.processos?.length) return [];

      const ordem = proc => proc.ctrl_processo?.ordem ?? Number.MAX_SAFE_INTEGER;

      return [...workflow.processos]
        .sort((a, b) => ordem(a) - ordem(b))
        .map(proc => {
          const status = this.determinarStatusProcesso(proc);
          
          return {
            title: proc.ctrl_processo?.processo || '-',
            aging: proc.aging_dias || '-',
            status: status
          };
        });
    },

    hasBloco() {
      return this.dadosFichaTecnicaTarefa?.tarefas_bloco?.length > 0;
    },

    circuitoSelecionado() {
      return {
        ...(getProvedorAtivo(this.dadosFichaTecnicaTarefa?.workflow) || {}),
        os: formatarOS(this.dadosFichaTecnicaTarefa?.workflow?.id)
      };
    },

    provedorTipo() {
      return getProvedorAtivoTipo(this.dadosFichaTecnicaTarefa?.workflow);
    }
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'salvarDadosFormulario',
      'buscarDadosFichaTecnica',
      'buscarDadosFichaTecnicaTarefa',
      'limparFichaTecnica',
      'buscarDadosHistoricoFichaTecnica',
      // 'listarCircuitoPcoTarefasLog',
      'listaDadosFichaTecnicaAdocao',
      'desfazerBloco'
    ]),

    ...mapActions('ctrlTratativas', [
      'listarTratativasSemTratamento'
    ]),

    ...mapActions('circuitos', ['recuperarCircuitoPorCodigoCir']),

    // ...mapActions('pcoCircuitoAnotacoes', [
    //   'listarPcoCircuitoAnotacoes'
    // ]),

    // ...mapActions('processos', [
    //   'listarProcessos'
    // ]),

    // ...mapActions('pcoCircuitoSaip', [
    //   'getDadosSaipPcoCircuito'
    // ]),

    // ...mapActions('pcoCircuitoSgap', [
    //   'getDadosSgaPlusPcoCircuito'
    // ]),

    // ...mapActions('pcoCircuitoWf1', [
    //   'getDadosWf1PcoCircuito'
    // ]),

    getTarefaSelecionada() {
      this.tarefaSelecionada = this.dadosFichaTecnicaTarefa;
    },

    async carregarDados() {
      localStorage.removeItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO);
      removerCookie("formulario_anotacao_minimizado");
      removerCookie("formulario_wf1_minimizado");

      await this.limparFichaTecnica();

      try {
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      } catch (error) {
        if (error.response?.status === 403) {
          this.$router.push({ name: 'filas-tarefas' });
          return;
        }
        throw error;
      }

      this.getTarefaSelecionada();

      if (this.circuitoSelecionado.pco_circuito_adocao_id) {
        await this.listaDadosFichaTecnicaAdocao(parseInt(this.circuitoSelecionado.pco_circuito_adocao_id));
      }
    },

    reloadData() {
      this.$router.push({ name: 'filas-tarefas' });
    },

    atualizaHistorico() {
      // Implementar lógica de atualização se necessário
    },

    excluindoBloco() {
      this.abrirModalDesfazerBlocoInteiro = true;
    },

    async forceComponentUpdate() {
      this.abrirModalSemTratamento = false
      if (this.$route.params?.pco_tarefa_id) {
        await this.buscarDadosFichaTecnica(this.$route.params.pco_tarefa_id);
      }
      this.alertaSolicitacaoCancelamento = false
    },

    async fecharModalSemTratamento() {
      this.abrirModalSemTratamento = false;
    },

    determinarStatusProcesso(processo) {
      const tarefas = processo.tarefas || [];

      if (!tarefas || tarefas.length === 0) {
        return 'incomplete';
      }

      // Verifica se tem tarefa interrompida
      const temTarefaInterrompida = tarefas.some(tarefa => 
        tarefa.status?.ctrl_status?.status === 'interrompida'
      );
      if (temTarefaInterrompida) {
        return 'stoped';
      }

      // Se o processo tem finalized_at preenchido, está completo
      if (processo.finalized_at) {
        return 'completed';
      }

      // Se tem ao menos uma tarefa aberta (sem finalized_at), status é current
      const temTarefaAberta = tarefas.some(tarefa => tarefa.finalized_at === null);
      if (temTarefaAberta) {
        return 'current';
      }

      // Fallback
      return 'incomplete';
    },
  },

  filters: {
    formataDataPrometida(val) {
      return moment(val).format('DD/MM/YYYY');
    }
  },

  watch: {
    async '$route.params.pco_tarefa_id'(newId, oldId) {
      if (newId && newId !== oldId) {
        await this.carregarDados();
      }
    },

    // abrirModalAnotacao (val) {
    //   // toda vez que houver uma abertura ou fechamento do modal de anotações
    //   // deve ser feita uma verificação se esse modal pode ser maximizado e hidratado
    //   // com os dados mantidos em cache dentro da variavel ('formulario_anotacao_minimizado')
    //   const formulario = recuperarCookie('formulario_anotacao_minimizado')
    //   if (formulario) {
    //     this.mostrarBotaoMaximizarAnotacoes = !val
    //   }
    // },

    abrirModalSemTratamento (val) {
      const formulario = recuperarCookie("formulario_atualizacao_minimizado")
      if (formulario) {
        this.mostrarBotaoMaximizarAtualizacao = !val
      }
    },

    // abrirModalWf1 (val) {
    //   // toda vez que houver uma abertura ou fechamento do modal de anotações
    //   // deve ser feita uma verificação se esse modal pode ser maximizado e hidratado
    //   // com os dados mantidos em cache dentro da variavel ('formulario_anotacao_minimizado')
    //   const formulario = recuperarCookie('formulario_wf1_minimizado')
    //   if (formulario) {
    //     this.mostrarBotaoMaximizarWf1 = !val
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
$primary: #E3262E;

.v-application.black {
  background-color: $primary !important;
  border-color: $primary !important;
  color: #fff !important;
}

.content-body {
  padding: 0 20px;
}

.text-capitalize {
  text-transform: capitalize;
}

.alerta-cancelamento {
  display: flex;
  padding: 10px;
  background: $primary;
  border-radius: 8px;
  animation-name: change;
  animation-duration: 2.8s;
  animation-iteration-count: infinite;
}

@keyframes change {	
  0% {
    background: #B41E13;
  }
  50% {
    background: #FB9C2D;
  }
  100% {
    background: #B41E13;
  }
}
</style>
